import React from "react";

function ServicesPage() {
  return (
    <div className="container pt-5 pb-5">
      <h1>All Our Services</h1>
      <p>This is the detailed services page.</p>
    </div>
  );
}

export default ServicesPage;
